const getOwnerDetails = (pageData) => {
  const { owner } = pageData;
  const {
    avatar_url: image, commercial, has_insurance: hasInsurance,
    joined_on: joinedOn, name, rate, id, trips_count: tripsCount,
    user_id: ownerUserId
  } = owner;
  return {
    image,
    commercial,
    hasInsurance,
    joinedOn,
    name,
    id,
    rate,
    tripsCount,
    ownerUserId
  };
};

export default getOwnerDetails;
